import { ReservationEventDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';

import { ReservationEvent } from '../interfaces/reservation/Reservation';

export function fromDto(reservationEventDto: ReservationEventDto): ReservationEvent {
  const { uuid, preReserve, ready, guestWillArrive, guestArrived, guestWillLeave, guestLeft } = reservationEventDto;
  return {
    uuid,
    preReserve: moment(preReserve),
    ready: ready != null ? moment(ready) : null,
    guestWillArrive: moment(guestWillArrive),
    guestArrived: guestArrived != null ? moment(guestArrived) : null,
    guestWillLeave: moment(guestWillLeave),
    guestLeft: guestLeft != null ? moment(guestLeft) : null,
  };
}

export function toDto(reservationEvent: ReservationEvent): ReservationEventDto {
  const { uuid, preReserve, ready, guestWillArrive, guestArrived, guestWillLeave, guestLeft } = reservationEvent;
  return {
    uuid,
    preReserve: preReserve.toISOString(),
    ready: ready != null ? ready.toISOString() : ready,
    guestWillArrive: guestWillArrive.toISOString(),
    guestArrived: guestArrived != null ? guestArrived.toISOString() : guestArrived,
    guestWillLeave: guestWillLeave.toISOString(),
    guestLeft: guestLeft != null ? guestLeft.toISOString() : null,
  };
}
